import { CardList, Container } from '@treams/treams-ui';
import { JobPosition, useJobPositionsQuery, JobPositionStatus } from '../generated/graphql';
import { SuitcaseIcon } from '@treams/treams-icons';
import JobsCard from './JobsCard';

export default function Jobs(props: { userID: string }) {
	const query = useJobPositionsQuery({
		variables: { id: props.userID, status: JobPositionStatus.Active },
	});

	return (
		<Container px={0} py={0}>
			<CardList
				disablePagination
				translationName="jobs"
				query={query}
				path="user.jobPositions"
				icon={<SuitcaseIcon />}
				renderCard={(item: JobPosition) => (
					<JobsCard key={item.id} userID={props.userID} job={item} />
				)}
				renderSkeleton={() => <JobsCard.Skeleton />}
			/>
		</Container>
	);
}
